import React, { useState } from "react";
import { Button, Input } from "antd";
import { useApolloClient } from "@apollo/client";

import { GET_ME } from "graphql/query/user-gql";
import { GET_FLOORING_CURSOR } from "graphql/query/flooring-gql";
import { GET_MODELS_IDS } from "graphql/query/model-gql";
import { EXHIBITION_TYPE_SYNC_MODEL } from "graphql/mutation/exhibition-gql";

import Flooring from "components/flooring";
import Exhibition from "components/exhibition";
import Icons from "components/icons";
import { useBreadCrumbs } from "components/use-hooks";
import { Tables, Forms } from "components/layout";
import { Localize, DrawerStandart } from "components/service";
import { localizeByKey } from "components/service/localize";
import type { TExhibitionType } from "components/exhibition/helpers/exhibition-types-helper";
const { Search } = Input;

const exhibitionBasePath = Exhibition.Const.basePath;
const basePath = Flooring.Const.basePath;
const tableHelper = Flooring.Helpers.TableMain;


interface IExhibitionFlooringSubPageProps
{
  exhibition: TExhibitionType | undefined;
}


const ExhibitionFlooringSubPage: React.FC<IExhibitionFlooringSubPageProps> = ({ exhibition }) =>
{
  const breadcrumbs = [
    {
      label: localizeByKey("BREADCRUMBS.Label_Exhibitions"),
      path: `${exhibitionBasePath}`,
    },
    {
      label: exhibition?.title ?? localizeByKey("VARIABLE.Label_EMPTY"),
      path: `${exhibitionBasePath}/${exhibition?.id}`,
    },
    {
      label: localizeByKey("BREADCRUMBS.Label_Flooring"),
      path: `${exhibitionBasePath}/${exhibition?.id}${basePath}`,
    },
  ];

  useBreadCrumbs(breadcrumbs);

  const client = useApolloClient();
  const cachedMe = client.readQuery({
    query: GET_ME,
  });

  const defaultLang = cachedMe.me.lang_api;

  const disabledColor = cachedMe.me.roles.filter(
    ({ slug }: { slug: string }) => slug === "role_library_manager"
  ).length
    ? true
    : false;

  const whereExhibitionTypeFlooring = {
    column: "ET_ID",
    value: exhibition?.id,
  };

  const [ searchText, setSearchText ] = useState("");
  const [ viewMode, setViewMode ] = useState<"table" | "grid">("grid");

  return (
    <Tables.Cursor
      model="flooringsCursor"
      query={GET_FLOORING_CURSOR}
      varSet={{
        perPage: 50,
        whereExhibitionTypeFlooring,
      }}
      extraObj={disabledColor}
      routeUrl={`${basePath}`}
      searchText={searchText}
      tableHelper={tableHelper}
      viewMode={viewMode}
      viewGrid={Flooring.Helpers.GridMain}
      language={defaultLang}
      currentObj={exhibition}
    >
      <div className="table-action-bar">
        <div className="col">
          <Search
            className="filter-search"
            prefix={<Icons.Search />}
            onChange={(e) => setSearchText(e.target.value)}
          />

          <Button disabled icon={<Icons.Filter />}>
            <span className="ellipsis">
              <Localize>FORMS.Button_Text_Filters</Localize>
            </span>
          </Button>
        </div>

        <div className="col">
          <div className="switch-btn-holder">
            {viewMode === "table" ? (
              <Button
                onClick={() => setViewMode("grid")}
                icon={<Icons.Grid />}
              />
            ) : (
              <Button
                onClick={() => setViewMode("table")}
                icon={<Icons.Table />}
              />
            )}
          </div>

          <DrawerStandart
            extraClass={"modal-form filters"}
            modalButton={
              <Button type="primary" icon={<Icons.Plus />}>
                <span className="ellipsis">
                  <Localize>GLOBAL.Button_Text_AddNew</Localize>
                </span>
              </Button>
            }
          >
            <strong className="modal-title">
              <span className="text">
                <Localize>FORMS.Title_Text_AddFlooringExhibition</Localize>
              </span>
            </strong>
            <Forms.ModelAddToForm
              modelCursorValue="id"
              modelCursorLabel={[ "title", "article" ]}
              modelImagePath="images[0]?.sizes['200x200']"
              action={() => { }}
              propsObj={{
                mutation: EXHIBITION_TYPE_SYNC_MODEL,
                queries: {
                  query: GET_FLOORING_CURSOR,
                  queryInitalVal: GET_MODELS_IDS,
                },
                queryNames: {
                  queryName: "flooringsCursor",
                  queryInitalValName: "getRelatedModelIds",
                },
                queryVars: {
                  queryVar: {
                    where: {},
                    whereExtra: !exhibition?.default
                      ? {
                        whereExhibitionTypeFlooring: {
                          column: "ET_ID",
                          value: exhibition?.organizer?.et_default_id,
                        },
                      }
                      : {},
                  },
                  queryInitalValVar: {
                    modelFrom: "ExhibitionType",
                    modelTo: "Flooring",
                    rel_id: exhibition?.id,
                  },
                },
                mutationName: "exhibitionTypeSyncModel",
                modelID: {
                  et_id: exhibition?.id,
                  model: "Flooring",
                },
              }}
            />
          </DrawerStandart>
        </div>
      </div>
    </Tables.Cursor>
  );
};

export default ExhibitionFlooringSubPage;
